import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import Inbox from './Inbox';
import Business from './Business';
import User from './User';
import Challenge from './Challenge';


const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    inboxReducer: Inbox,
    business: Business,
    user:User,
    challenge: Challenge,

});

export default reducers;